import { Stack } from "@mui/material";
import { useTranslation } from "react-i18next";
import NoData from "../../../../components/no-data/NoData";
import { IPermissionModel } from "../../../../common/models/IPermissionModel";
import PermissionsListItem from "./PermissionsListItem";

export enum PermissionsListTypeEnum {
    Empty = 0,
    NoData = 1,
    Custom = 2,
    ElynxAdminUser = 3,
    ElynxAdminRole = 4,
    DefaultRole = 5,
    EveryoneRole = 6
}

export type PermissionsListProps = {
    type: PermissionsListTypeEnum,
    permissions: IPermissionModel[] | undefined,
    noDataTitle: string,
    noDataText: string;
    expansionKey: string,
    expansion: { [key: string]: boolean; },
    toggleExpansion: (key: string) => void;
};

export default function PermissionsList({
    type,
    permissions,
    noDataTitle,
    noDataText,
    expansionKey,
    expansion,
    toggleExpansion
}: PermissionsListProps) {

    const { t } = useTranslation();

    return (
        <>
            {type === PermissionsListTypeEnum.NoData
                ? <NoData
                    title={noDataTitle}
                    text={noDataText}
                />
                : type === PermissionsListTypeEnum.ElynxAdminUser
                    ? <NoData
                        title={t("permissionsList.eLynxAdminUserPermissions.title")}
                        text={t("permissionsList.eLynxAdminUserPermissions.text")}
                    />
                    : type === PermissionsListTypeEnum.ElynxAdminRole
                        ? <NoData
                            title={t("permissionsList.eLynxAdminRolePermissions.title")}
                            text={t("permissionsList.eLynxAdminRolePermissions.text")}
                        />
                        : type === PermissionsListTypeEnum.DefaultRole
                            ? <NoData
                                title={t("permissionsList.defaultRolePermissions.title")}
                                text={t("permissionsList.defaultRolePermissions.text")}
                            />
                            : type === PermissionsListTypeEnum.EveryoneRole
                                ? <NoData
                                    title={t("permissionsList.everyoneRolePermissions.title")}
                                    text={t("permissionsList.everyoneRolePermissions.text")}
                                />
                                : type === PermissionsListTypeEnum.Custom
                                    ? <Stack direction="column" spacing={1}>
                                        {permissions?.map((o, index) => {
                                            return (
                                                <PermissionsListItem
                                                    key={index}
                                                    permissions={o}
                                                    expansionKey={expansionKey}
                                                    expansion={expansion}
                                                    toggleExpansion={toggleExpansion}
                                                />
                                            );
                                        })}
                                    </Stack>
                                    : <></>
            }
        </>
    );
}


